import {
    Grid,
    Stack,
    Title
} from '@mantine/core';
import {
    PlatformServicePlan,
    PlatformServicePlanType
} from "@flexinet/ui-components";
import {Product} from "../types.ts";
import {stage} from '../../../config/stage.ts';


export const ApplicationProductsComponent = ({products}: { products: Product[] }) => {

    if (!products) {
        return null;
    }

    if (products.length === 0) {
        return <Stack align={'center'}><Title order={3}>No Service Plans found</Title></Stack>;
    }

    const plans = products.map(product => {
        return {
            ...product,
            description: product.shortDescription,
            prices: product.prices?.items.map((price: { amount: number, billingPeriod: string }) => {
                return {
                    amount: price.amount / 100,
                    billingPeriod: price.billingPeriod,
                }
            }),
            features: product.lineItems?.items.map((lineItem: { productFeature: { id: string, name: string } }) => {
                return {
                    id: lineItem.productFeature.id,
                    title: lineItem.productFeature.name,
                    supported: true
                }
            })
        }
    })

    // if the number of plans is one, two, three or four then calculate base span by dividing the total number of columns by the number of plans
    const validPlansCount = [1, 2, 3, 4].includes(plans.length)
    const colSpan = validPlansCount ? 12 / plans.length : 6


    return (
        <Grid grow>
            {plans.map(plan => {
                return (
                    <Grid.Col
                        key={plan.id}
                        span={{
                            base: 12,
                            sm: colSpan,
                            lg: colSpan
                        }}>
                        <PlatformServicePlan
                            plan={plan as PlatformServicePlanType}
                            stage={stage}/>
                    </Grid.Col>)


                // {user && typeof plan.current !== 'undefined' ? (plan.current ?
                //     <FlexiButton disabled={true}>Current Plan</FlexiButton> :
                //     <FlexiButton>Upgrade</FlexiButton>) : null}


            })}
        </Grid>
    );
};
